<template>
	<MStateBox :loading="isLoading" :empty="isEmpty">
		<div class="all-activity-wrapper">
			<div v-for="(item, index) in currentData" :key="index" class="all-activity-item" @click="handleClick(item)">
				<div class="activity-main">
					<div class="activity-title">{{ item.title }}</div>
					<div class="activity-date mt-8">{{ formatActivityDate(item) }}</div>
				</div>
			</div>
		</div>
		<el-pagination
			@size-change="changePageSize"
			@current-change="changeCurrentPage"
			:current-page="currentPage"
			:page-sizes="pageSizes"
			:page-size="pageSize"
			:layout="pageLayout"
			:total="pageTotal"
			background
			hide-on-single-page
		></el-pagination>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import dayjs from 'dayjs';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { usePaginationPC } from '@rebuild/hooks/load-more/usePaginationPC';
import { useCurrentContext, useCurrentReactive } from './context';

const BUSINESS_TYPES = {
	RESEARCH: 3,
	ROADSHOW: 8,
	OFFLINE_ACTIVITY: 9
};

const { investment_activity } = useModuleData();

const currentData = computed(() => {
	const { rows = [] } = investment_activity.data || {};
	return rows;
});

const isLoading = computed(() => investment_activity.loading);
const isEmpty = computed(() => investment_activity.empty || !currentData.value.length);

// 分页功能
const handlePaginationChange = () => {
	loadData();
};
const {
	currentPage,
	pageSize,
	pageSizes,
	pageLayout,
	pageTotal,
	changePageSize,
	changeCurrentPage,
	changePageTotal,
	refreshPagination
} = usePaginationPC({
	bindChange: handlePaginationChange
});

const context = useCurrentContext();
const loadData = async () => {
	await investment_activity.refresh({
		pagestart: currentPage.value - 1,
		pagenum: pageSize.value,
		title: currentSearchValue.value,
		...context.params
	});

	const { total = 0 } = investment_activity.data || {};
	changePageTotal(total);
};

const currentSearchValue = ref('');
const search = searchValue => {
	currentSearchValue.value = searchValue;
	refreshPagination();
};

const isResearch = item => item.businessTypes === BUSINESS_TYPES.RESEARCH;

const formatActivityDate = item => {
	const format = isResearch(item) ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm';
	return dayjs(Number(item.date)).format(format);
};

const { viewActivity } = useCurrentReactive();
const handleClick = item => {
	return viewActivity(item);
};

onMounted(() => {
	loadData();
});

defineExpose({
	search
});
</script>

<style lang="less" scoped>
.all-activity-wrapper {
	.all-activity-item {
		display: flex;
		padding: 32px 0;

		& + .all-activity-item {
			border-top: 1px solid #e5e6eb;
		}
		.activity-main {
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.activity-title {
				font-size: 16px;
				font-weight: 500;
				line-height: 24px;
				color: #1d2129;
				cursor: pointer;
			}
			.activity-date {
				font-size: 12px;
				font-weight: 400;
				line-height: 18px;
				color: #4e5969;
			}
		}
		.activity-cover {
			margin-left: 18px;
			flex: none;
			width: 300px;
			height: 229px;
			cursor: pointer;
		}
	}
}
</style>
